import { createStore } from 'vuex'
import user from './modules/user'
import route from './modules/route'
const store = createStore({
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        user,
        route,
    }
})

export default store